<template>
  <div id="content">
    <h1>关于星空笔记</h1>

    <img src="https://www.steemjiang.com:8081/ipfs/Qmf1KNVAxc3oEmYTWnu2NrCKCkhs6xVkCbuRsd2F8Asmbq" alt="星空笔记"><br><br>

    星空笔记，基于Steem和IPFS的区块链笔记，@lemooljiang创建。数据存储在Steem区块链上，图片存在IPFS网络中，前端则使用IndexedDB数据库，几者相结合，有着神奇的效果！<br><br>

    星空笔记是一个去中心的应用！ 它和比特币的离线钱包类似，可以很方便地在本地构建，无需服务器。<br><br>

    当然，为了方便大家使用，我把它上传到github page中，大家可以直接访问：https://starnote.github.io<br><br>

    <h4>本地构建说明</h4>
    本地环境：Apache 或 Nginx<br>
    仓库地址： https://github.com/starnote/starnote.github.io<br>
    将仓库中的“index.html” 和 “static” 下载到本地，放进Apache 或 Nginx的根目录即可，http://localhost<br><br>


  </div>
</template>

<script>

  export default {
    name: "About",
    data() {
      return {

      }
    },

    mounted() {


    },

  }
</script>

<style scoped>
  h1{
    font-size: 2rem;
    padding-left: 40%;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
  }
  #content{
    color: rgba(55,53,58,0.75);
    align: center;
    margin: 1rem auto;
    width: 75%;
    padding-bottom: 0.2rem;
  }

  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: darkcyan;
    text-decoration: none;
  }

  .btn-outline-primary {
    color: rgba(55,53,58,0.75);
    border-color: rgba(55,53,58,0.75);
  }
  .btn-outline-primary:hover{
    background-color: chocolate;
  }
</style>

